const getGaugePlotBands = (type, value) => {
  const plotBands = [];
  let min;
  let max;

  if (type === 'Cool Delta T') {
    min = 4;
    max = 22;
    plotBands.push({
      from: 15.01,
      to: 22,
      thickness: '50%',
      color: value >= 15.01 && value <= 22 ? '#32D87E' : '#152B38',
    }, {
      from: 11.01,
      to: 15,
      thickness: '50%',
      color: value >= 11.01 && value <= 15 ? '#FFAB00' : '#2B272B',
    }, {
      from: 4.01,
      to: 11,
      thickness: '50%',
      color: value >= 4.01 && value <= 11 ? '#F83356' : '#3B2B47',
    });

    if (value < min) {
      min = Math.round(value) - 2;
      plotBands.push({
        from: min,
        to: 4,
        thickness: '50%',
        color: value >= min && value <= 4 ? '#F7433A' : '#3B2B47',
      });
    }

    if (value > max) {
      max = Math.round(value) + 2;
      plotBands.push({
        from: 22.01,
        to: max,
        thickness: '50%',
        color: value >= 22.01 && value <= max ? '#F7433A' : '#3B2B47',
      });
    }
  }

  if (type === 'Heat Delta T') {
    min = 0;
    max = 35;
    plotBands.push({
      from: 22.01,
      to: 35,
      thickness: '50%',
      color: value >= 22.01 && value <= 35 ? '#4CD87D' : '#264D4B',
    }, {
      from: 13.01,
      to: 22,
      thickness: '50%',
      color: value >= 13.01 && value <= 22 ? '#FFAB00' : '#433D37',
    }, {
      from: 0.01,
      to: 13,
      thickness: '50%',
      color: value >= 0.01 && value <= 13 ? '#F7433A' : '#3B2B47',
    });

    if (value < min) {
      min = Math.round(value) - 2;
      plotBands.push({
        from: min,
        to: 0,
        thickness: '50%',
        color: value >= min && value <= 0 ? '#F7433A' : '#3B2B47',
      });
    }

    if (value > max) {
      max = Math.round(value) + 2;
      plotBands.push({
        from: 35.01,
        to: max,
        thickness: '50%',
        color: value >= 35.01 && value <= max ? '#F7433A' : '#3B2B47',
      });
    }
  }

  if (type === 'Cool Supply Air') {
    min = 45;
    max = 80;
    plotBands.push({
      from: 45.01,
      to: 60,
      thickness: '50%',
      color: value >= 45.01 && value <= 60 ? '#4CD87D' : '#264D4B',
    }, {
      from: 60.01,
      to: 65,
      thickness: '50%',
      color: value >= 60.01 && value <= 65 ? '#FFAB00' : '#433D37',
    }, {
      from: 65.01,
      to: 80,
      thickness: '50%',
      color: value >= 65.01 && value <= 80 ? '#F7433A' : '#3B2B47',
    });

    if (value < min) {
      min = Math.round(value) - 2;
      plotBands.push({
        from: min,
        to: 45,
        thickness: '50%',
        color: value >= min && value <= 45 ? '#F7433A' : '#3B2B47',
      });
    }

    if (value > max) {
      max = Math.round(value) + 2;
      plotBands.push({
        from: 80.01,
        to: max,
        thickness: '50%',
        color: value >= 80.01 && value <= max ? '#F7433A' : '#3B2B47',
      });
    }
  }

  if (type === 'Heat Supply Air') {
    min = 60;
    max = 110;
    plotBands.push({
      from: 90.01,
      to: 110,
      thickness: '50%',
      color: value >= 90.01 && value <= 110 ? '#4CD87D' : '#264D4B',
    }, {
      from: 80.01,
      to: 90,
      thickness: '50%',
      color: value >= 80.01 && value <= 90 ? '#FFAB00' : '#433D37',
    }, {
      from: 60.01,
      to: 80,
      thickness: '50%',
      color: value >= 60.01 && value <= 80 ? '#F7433A' : '#3B2B47',
    });

    if (value < min) {
      min = Math.round(value) - 2;
      plotBands.push({
        from: min,
        to: 60,
        thickness: '50%',
        color: value >= min && value <= 60 ? '#F7433A' : '#3B2B47',
      });
    }

    if (value > max) {
      max = Math.round(value) + 2;
      plotBands.push({
        from: 110.01,
        to: max,
        thickness: '50%',
        color: value >= 110.01 && value <= max ? '#F7433A' : '#3B2B47',
      });
    }
  }
  return {
    plotBands,
    min,
    max,
    gaugeValue: value,
  };
};

export default getGaugePlotBands;
